/**
 * 获取文件名后缀，比如：.xls, .png
 * @param {string} filename 文件名
 */
export function getFileNameSuffix(filename) {
    const startIndex = filename.lastIndexOf(".");
      if(startIndex != -1) {
          const fileSuffix = filename.substring(startIndex, filename.length)
          return fileSuffix.toLowerCase()
      } 
          return ''
      
}